export class GlobalVariables {
  //Local
  // public static appURL: string = "http://localhost:3000/";
  // public static appCustomerURL: string = "http://localhost:4200/"

  //TEST
  //public static appURL: string = "http://52.15.132.22:3000/";
  //public static appCustomerURL: string = "http://coupon.customer.s3-website.us-east-2.amazonaws.com/"

  //UAT
  public static appURL: string = "https://api.scanfluence.com/";
  public static appCustomerURL: string = "https://uat.scancoupon.live/";
  public static couponShareURL: string = "https://share.scanfluence.com/";
  public static hasImplement: boolean = true;


  public static angularURL: string = "https://uat.scanfluence.com/";
  public static genericURL: string = "http://localhost:8080/";
  public static guestAppUrl: string = "http://localhost:4200/";
  public static loginUserInfo: any;
  public static loginFlag: boolean = false;

  public static vcardURL: string = "https://api.scancontact.app/";
  public static alyroUiUrl: string = "https://scancontact.app";
}
